export default class FormatUtils {
    static removerMascara(valor) {
        return (valor || "").replace(/[^a-z0-9]/gi, "");
    }

    static formatarCPF(valor) {
        return (valor || "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    static formatarCNPJ(valor) {
        return (valor || "").replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }

    static formatarCEP(valor) {
        return (valor || "").replace(/(\d{5})(\d{3})/, "$1-$2");
    }

    static formatarTelefone(valor) {
        if (!valor) return "";

        const numbers = String(valor).replace(/\D/g, "");

        // 1) SAG — qualquer número que comece com 0 (ex: 0800, 0300, 0500, 0900, 4004)
        if (numbers.startsWith("0")) {
            // Formato: 9999 999 9999
            return numbers.replace(/^(\d{4})(\d{3})(\d{4})$/, "$1 $2 $3");
        }

        // 2) DDD + número
        if (numbers.length >= 2) {
            const ddd = numbers.substring(0, 2);
            const afterDDD = numbers.substring(2);

            // Número fixo (começa com 2,3,4,5)
            if (["2", "3", "4", "5"].includes(afterDDD[0])) {
                // Formato fixo: (DD) 9999-9999
                return numbers.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
            }

            // Celular (começa com 9)
            if (afterDDD[0] === "9") {
                // Formato celular: (DD) 99999-9999
                return numbers.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
            }

            // Qualquer outra coisa → celular (por regra da detectarMascara)
            if (afterDDD.length >= 4) {
                return numbers.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
            }
        }

        // 3) Sem DDD (usuário digitou pouco)
        if (numbers.length === 8) {
            return numbers.replace(/^(\d{4})(\d{4})$/, "$1-$2");
        }

        if (numbers.length === 9) {
            return numbers.replace(/^(\d{5})(\d{4})$/, "$1-$2");
        }

        return valor; // se não couber em nada acima, retorna como veio
    }

    static formatarValorTela(valor, casas = 0) {
        let formatado = parseFloat(valor || 0).toFixed(casas);
        return casas == 0 ? formatado : formatado.split(".").join(",");
    }

    static formatarValorBanco(valor, casas = 0) {
        return parseFloat(
            String(valor || "0")
                .split(".")
                .join("")
                .split(",")
                .join(".")
        ).toFixed(casas);
    }

    static formatarCompetenciaTela(competencia) {
        return competencia ? `${String(competencia).substring(4, 6)}/${String(competencia).substring(0, 4)}` : "";
    }

    static formatarCompetenciaBanco(competencia) {
        return competencia ? `${String(competencia).split("/")[1]}${String(competencia).split("/")[0]}` : "";
    }
}
